import './Accordian.css';

const AccordianItem = ({ item, active, index, onClick }) => {


    return (
        <div className={`accordian-item ${active && "active"}`} onClick={() => onClick(index)}>
            <div className='title'>
                <i className='dropdown icon'></i>
                <h4>{item.title}</h4>
            </div>
            <div className='content'>
                <p>{item.content}</p>
            </div>  
        </div>

    )  
}



export default AccordianItem